import { ResumeProfileModel } from 'generated-types/skills/resume_profile';
import { Button, ButtonGroup, FlexboxGrid } from 'rsuite';

const ProfileModeButtons = ({
    selectedResumeProfile,
    editAllowed,
    editMode,
    isLoading,
    onClose,
    setEditMode,
}: {
    selectedResumeProfile: ResumeProfileModel | undefined;
    editAllowed: boolean;
    editMode: boolean;
    isLoading: boolean;
    onClose: () => void;
    setEditMode: (value: boolean) => void;
}) =>
    editAllowed ? (
        <FlexboxGrid.Item style={{ textAlign: 'right' }} colspan={3}>
            {editMode ? (
                <ButtonGroup>
                    <Button appearance="primary" color="green" type="submit" loading={isLoading}>
                        Save
                    </Button>
                    <Button onClick={() => onClose()}>Close</Button>
                </ButtonGroup>
            ) : (
                (selectedResumeProfile?.headline || selectedResumeProfile?.about) && (
                    <Button onClick={() => setEditMode(true)}>Edit</Button>
                )
            )}
        </FlexboxGrid.Item>
    ) : null;

export default ProfileModeButtons;
